/**
* @file: 购买item组件
* @author: wence
*/
import React, {Component} from 'react';
import PropType from 'prop-types';

import './item.less';
export default class Item extends Component {
    static propTypes = {
        item: PropType.object,
        onClick: PropType.func
    };

    render() {
        const {item, onClick} = this.props;

        return (
            <div className="saas-buy-item">
                <div className="saas-buy-name">
                    <span className={item.is_hot ? 'hot' : null}>{item.service_name}</span>
                    {item.is_hot ? <i className="saas-buy-hot" /> : null}
                </div>
                <div className="saas-buy-text">
                    {item.service_desc}
                </div>
                <div className="saas-buy-info">
                    <a href={item.url} target="_blank">查看详情 <i /></a>
                </div>
                <div className="saas-buy-item-hint">
                    <span>免费体验时长：</span>
                    <span>{item.is_buy ? '-' : item.capacity}</span>
                </div>
                <div
                    className={item.is_buy ? 'saas-buy-btn disable' : 'saas-buy-btn'}
                    onClick={onClick}>
                    {item.is_buy ? '已领取' : '免费领取'}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/securityPlan/item.jsx